import { translationBaseKey } from '../decorators/translation-base-key.decorator';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('organization-update-options')
export class OrganizationUpdateOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Input
  })
  name: string;
}